import React, {useContext, useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as firebaseui from 'firebaseui';
import {useHistory} from 'react-router-dom';
import {
  fireSignUp,
  fireScreenView,
  SCREEN_NAMES,
} from '../../../util/Analytics';
import {theme} from '../../../Theme';
import {firebaseAuth} from '../../../App';
import {NewProjectContext} from '../utils/NewProjectContext';
import {useSetRecoilState} from 'recoil';
import {loadingState} from '../../../recoil/bidmiiCustomLoader/bidmiiCustomLoaderAtom';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',

    '& .inner': {
      maxWidth: 300,
      margin: '0 auto',
      textAlign: 'center',

      '& img': {
        width: 250,
        marginBottom: 24,
      },

      '& .innerH4': {
        fontWeight: 'bold',
        color: 'rgba(0, 0, 0, 0.87)',
      },

      '& .innerH5': {
        fontWeight: 'bold',
        color: theme.palette.primary.light,
      },

      '& .innerH6': {
        fontWeight: 400,
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
  },

  button: {
    backgroundColor: theme.palette.primary.main,
    width: '100%',
    color: theme.palette.secondary.main,
    fontSize: 15,
    marginTop: 30,
  },
}));

const AnonProjectLogin = (props: $TSFixMe) => {
  useEffect(() => {
    fireScreenView(SCREEN_NAMES.NEW_PROJECT_WIZARD_LOGIN);
  }, []);

  const [ui] = useState(
    firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebaseAuth),
  );

  const classes = useStyles();
  const history = useHistory();
  const setLoading = useSetRecoilState(loadingState);
  const {project, setProject, setNewProjectStep} =
    useContext(NewProjectContext);

  const initialiseFirebaseUI = () => {
    window.localStorage.setItem('anonymousProjectCreated', '1');

    const checkContainer = setInterval(function () {
      if (document.getElementById('firebaseui-auth-container')) {
        ui.start('#firebaseui-auth-container', {
          callbacks: {
            signInSuccessWithAuthResult: function (authResult, redirectUrl) {
              setLoading(true);
              if (authResult.additionalUserInfo.isNewUser === true) {
                sessionStorage.setItem('isNewUser', '1');
                sessionStorage.setItem('email', authResult.user.email);
                fireSignUp(authResult.user);
              }

              let inIframe = false;
              try {
                inIframe = window.self !== window.top;
              } catch (e) {
                inIframe = true;
              }
              if (inIframe) {
                window.parent.postMessage('redirectToBIdmii', '*');
              } else {
                if (authResult.additionalUserInfo.isNewUser) {
                  window.sessionStorage.setItem('isNewUser', '1');
                  process.env.NODE_ENV === 'development' &&
                    console.log('NEW PROJECT LOGIN history.push!!!!!');
                  history.push('/new/user/signup/homeowner/1');
                  return false;
                }
                window.localStorage.setItem('anonymousProjectCreated', '1');
                sessionStorage.setItem(
                  'signInSuccessUrl',
                  `/myRfps/${project.uid}?projectCreated=true`,
                );
                setNewProjectStep(0);
                setProject({});
              }
              return false;
            },
          },
          tosUrl: 'https://www.bidmii.com/terms',
          privacyPolicyUrl: 'https://www.bidmii.com/privacy-policy',
          signInOptions: [
            {
              provider: 'google.com',
              fullLabel: 'Continue with Google',
              buttonColor: theme.palette.primary.main,
            },
            {
              provider: 'facebook.com',
              fullLabel: 'Continue with Facebook',
              buttonColor: theme.palette.primary.main,
            },
            {
              provider: 'apple.com',
              buttonColor: theme.palette.primary.main,
            },
            {
              provider: 'password',
              fullLabel: 'Continue with Email',
              buttonColor: theme.palette.primary.main,
              requireDisplayName: false,
            },
          ],
          signInFlow: 'popup',
        });
        clearInterval(checkContainer);
      }
    }, 50);
  };

  useEffect(() => {
    initialiseFirebaseUI();
    if (sessionStorage.getItem('inviteUserId')) {
      sessionStorage.setItem('inviteRfpId', props.project.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="column"
        height="100%"
        justifyContent="center"
        alignItems="center">
        <div className="inner">
          <img
            src={'https://cdn.bidmii.com/media/web_assets/logo.webp'}
            alt="Bidmii Logo"
            style={{width: 150}}
          />
          <Typography variant="h6" gutterBottom>
            Create an account to go live!
          </Typography>
        </div>
        <div className="social-btn-group">
          <div
            id="firebaseui-auth-container"
            style={{
              minHeight: 250,
              maxWidth: '100vw',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />
        </div>
      </Grid>
    </div>
  );
};

export default AnonProjectLogin;
